import { createFragment } from "../utilities/elements.js";
import { defineElement } from "./registry.js";
import { DickTokStandaloneComponent } from "./StandaloneComponent.js";

export class DickTokPostGrid extends DickTokStandaloneComponent {
  static services = ["HistoryService", "PostApiService"];

  static attributes = [{ name: "next", type: String, optional: true }];

  static targets = ["loadingIndicator", "loadingTrigger"];

  static template = createFragment`
    <div class="dt-postgrid__container">
        <slot data-target="slot"></slot>
    </div>
    <div data-target="loadingIndicator" class="dt-postgrid__loading-indicator">
        <i class="fa-sharp fa-solid fa-spinner-third fa-spin fa-4x"></i>
    </div>
    <div data-target="loadingTrigger" class="dt-postgrid__loading-trigger"></div>
  `;

  /** @type {boolean} If thumbnails are loading */
  #loading = false;
  /** @type {boolean} If there are more thumbnails to load in the "next" direction. */
  #hasMoreNext = false;

  connectedCallback() {
    super.connectedCallback();
    this.#setupPagination();
    this.#observeLoadNextThumbnails();
  }

  // nextChanged(oldValue, newValue) {
  //   // Do this in a callback since next can be updated by the parent element on
  //   // the search page when the query changes. This is also called when this
  //   // component updates next in #loadNextThumbnails().
  //   if (newValue) {
  //     this.#hasMoreNext = true;
  //     // When search query changes, its impossible to load more because the
  //     // loadingTriggerTarget is already intersecting the expanded rootMargin,
  //     // so it never triggers the IntersectionObserver. Handle this by manually
  //     // loading the next page.
  //     if (query !== this.#query) {
  //       // Update #query first as otherwise this will create an infinite loop
  //       // when #loadNextThumbnails() updates next, which calls this callback.
  //       this.#query = query;
  //       this.#loadNextThumbnails();
  //     }
  //   } else {
  //     this.#hasMoreNext = false;
  //     this.#query = undefined;
  //   }
  // }

  /** Check pagination tokens to initialize #hasMoreNext */
  #setupPagination() {
    this.#hasMoreNext = this.hasNext;
  }

  #observeLoadNextThumbnails() {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.boundingClientRect.height > 0 && entry.isIntersecting) {
          this.#loadNextThumbnails();
        }
      },
      {
        root: null,
        rootMargin: "0px 0px 50%",
        threshold: [1],
      },
    );
    observer.observe(this.loadingTriggerTarget);
    this.disconnectSignal.addEventListener("abort", () => {
      observer.disconnect();
    });
  }

  async #loadNextThumbnails() {
    if (!this.#hasMoreNext) {
      return;
    }
    if (this.#loading) {
      return;
    }
    this.#loading = true;
    this.loadingIndicatorTarget.style.display = "flex";
    try {
      // Cache the next attribute value so we can throw out stale results
      const token = this.next;
      const { items, next } = await this.postApiService.getPosts(
        token,
        "thumbnail",
      );
      // The component was updated and results are stale, throw this out
      if (this.next !== token) {
        return;
      }
      // Add the posts as child elements in the light DOM
      this.#hasMoreNext = items.length > 0;
      this.append(...items);
      this.next = next;
    } catch (error) {
      this.error("Error loading post thumbnails in DickTokPostGrid", error);
    } finally {
      this.loadingIndicatorTarget.style.display = "none";
      this.#loading = false;
    }
  }
}

defineElement("dt-postgrid", DickTokPostGrid);
